'use client'

import textBodySRegular from '@fukku/styles/texts/textBodySRegular.module.css'

import { useDelayedDays } from 'pdp/src/contexts/DelayedDaysProvider/DelayedDaysProvider'
import { cx } from 'utils/cx'
import styles from './SizeDelayedLabel.module.css'

export interface SizeDelayedLabelProps {
	readonly showLastUnits: boolean
}

export function SizeDelayedLabel({
	showLastUnits,
}: SizeDelayedLabelProps): React.ReactNode {
	const { deliveryTimeMessage } = useDelayedDays()

	return (
		<span
			className={cx(
				!!showLastUnits && textBodySRegular.className,
				styles.sizeDelayedLabel
			)}
		>
			<span>{deliveryTimeMessage}</span>
		</span>
	)
}
